module.exports = __webpack_public_path__ + "static/media/HAUX_MAIS_VIDA_CLIENTES_1.1ef2c826.pdf";